import React from "react";
import { MeasurementUnitShape } from "../../interfaces/classTypes";
let includedMeasurementUnits = [];

export class MeasurementUnit {
  public id: number;
  public label: string;
  public name: string;
  constructor(data: MeasurementUnitShape) {
    this.id = data.id;
    this.label = data.label;
    this.name = data.name;
    this.save();
  }
  save() {
    includedMeasurementUnits.push(this);
  }
  static includedMeasurementUnits() {
    return includedMeasurementUnits;
  }
}
